import {
  PlusOutlined,
  MinusOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
} from "@ant-design/icons";
import { Input, Checkbox, Form, Button, Divider, Select, Row, Col } from "antd";
import ContentPadding from "../ContentConfig/ContentPadding";
import FormCustomIDField from "../ContentConfig/FormCustomIDField";
import { useRef } from "react";
import TrimmedInput from "../FormCommonField/FormTrimmedInput";

const DEFAULT_PHONE_LIST = [
  { label: "+852 🇭🇰", value: "852" }, // 香港
  { label: "+86 🇨🇳", value: "86" }, // 中国
  { label: "+853 🇲🇴", value: "853" },// 澳门
];

const PHONE_REGION_LIST = [
  { label: "+852 🇭🇰", value: "852" }, // 香港
  { label: "+86 🇨🇳", value: "86" }, // 中国
  { label: "+853 🇲🇴", value: "853" }, // 澳门
  { label: "+886 🇨🇳", value: "886" }, // 台湾
  { label: "+81 🇯🇵", value: "81" },  // 日本
  { label: "+60 🇲🇾", value: "60" },  // 马来西亚
  { label: "+62 🇮🇩", value: "62" },  // 印度尼西亚
  { label: "+63 🇵🇭", value: "63" },  // 菲律宾
  { label: "+64 🇳🇿", value: "64" },  // 新西兰
  { label: "+65 🇸🇬", value: "65" },  // 新加坡
  { label: "+66 🇹🇭", value: "66" },  // 泰国
  { label: "+673 🇧🇳", value: "673" }, // 文莱
  { label: "+82 🇰🇷", value: "82" },  // 韩国
  { label: "+84 🇻🇳", value: "84" },  // 越南
  { label: "+855 🇰🇭", value: "855" }, // 柬埔寨
  { label: "+880 🇧🇩", value: "880" }, // 孟加拉国
  { label: "+90 🇹🇷", value: "90" },  // 土耳其
  { label: "+92 🇵🇰", value: "92" },  // 巴基斯坦
  { label: "+94 🇱🇰", value: "94" },  // 斯里兰卡
  { label: "+960 🇲🇻", value: "960" }, // 马尔代夫
  { label: "+961 🇱🇧", value: "961" }, // 黎巴嫩
  { label: "+962 🇯🇴", value: "962" }, // 约旦
  { label: "+964 🇮🇶", value: "964" }, // 伊拉克
  { label: "+966 🇸🇦", value: "966" }, // 沙特阿拉伯
  { label: "+1 🇺🇸", value: "1" },  // 美国
  { label: "+44 🇬🇧", value: "44" },  // 英国
  { label: "+61 🇦🇺", value: "61" },  // 澳大利亚
  { label: "+33 🇫🇷", value: "33" },  // 法国
  { label: "+49 🇩🇪", value: "49" },  // 德国
  { label: "+55 🇧🇷", value: "55" },  // 巴西
  { label: "+91 🇮🇳", value: "91" },  // 印度
  { label: "+971 🇦🇪", value: "971" }, // 阿拉伯联合酋长国
  { label: "+39 🇮🇹", value: "39" },  // 意大利
  { label: "+234 🇳🇬", value: "234" }, // 尼日利亚
];

const DummyPhoneField = ({ value }) => {
  return <Button style={{ width: "100%" }}>{value}</Button>;
};

export default ({node}) => {
  const form = Form.useFormInstance();
  const defalutLabel = node?.data?.label || ""
  const codeRef = useRef();
  return (
    <>
      <Form.Item label="Label" name="label" rules={[{ required: true, max: 256 }]}>
      <TrimmedInput/>
      </Form.Item>
      <Form.Item name="hideLabel" valuePropName="checked">
        <Checkbox>Hide Label</Checkbox>
      </Form.Item>
      <FormCustomIDField />
      <Form.Item label="Placeholder" name="placeholder">
        <Input maxLength={50} style={{ 
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }}/>
      </Form.Item>
      <Form.Item name="required" valuePropName="checked">
        <Checkbox>Required</Checkbox>
      </Form.Item>
      <label>Options</label>
      <Form.List name="options" >
        {(fields, { add, move, remove }, { errors }) => (
          <>
            {fields.map((field, index) => {
              return (
                <div
                  key={field.name}
                  style={{ display: "flex", alignItems: "baseline" }}
                >
                  <Form.Item
                    {...field}
                    name={[field.name, "label"]}
                    style={{ width: "calc(100% - 60px)" }}
                  >
                    <DummyPhoneField />
                  </Form.Item>
                  <Button
                    icon={<ArrowUpOutlined />}
                    size="small"
                    disabled={index === 0}
                    shape="circle"
                    type="primary"
                    style={{
                      marginTop: 5,
                      marginLeft: 5,
                    }}
                    onClick={() => move(index, index - 1)}
                  />
                  <Button
                    icon={<ArrowDownOutlined />}
                    size="small"
                    disabled={fields.length === index + 1}
                    shape="circle"
                    type="primary"
                    style={{
                      marginTop: 5,
                      marginLeft: 5,
                    }}
                    onClick={() => move(index, index + 1)}
                  />
                  <Button
                    icon={<MinusOutlined />}
                    danger
                    size="small"
                    disabled={fields.length <= 1}
                    shape="circle"
                    type="primary"
                    style={{
                      marginTop: 5,
                      marginLeft: 5,
                    }}
                    onClick={() => remove(field.name)}
                  />
                </div>
              );
            })}
            <Form.Item shouldUpdate>
              <Form.ErrorList errors={errors} />
              <Row gutter={8}>
                <Col span={16}>
                  <Form.Item shouldUpdate>
                    {({ getFieldValue }) => {
                      const existList = getFieldValue("options") || DEFAULT_PHONE_LIST;
                      return (
                        <Select
                          key={existList.length}
                          showSearch
                          placeholder="Select a region code"
                          onChange={(v) => {
                            const found = PHONE_REGION_LIST.find(
                              (item) => item.value === v
                            );
                            codeRef.current = found;
                          }}
                          options={PHONE_REGION_LIST.filter(
                            (it) =>
                              !existList.find((ex) => ex.value === it.value)
                          )}
                        />
                      );
                    }}
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Button
                    type="primary"
                    style={{ width: "100%" }}
                    onClick={() => {
                      const exist = form.getFieldValue("options");
                      if (!codeRef.current) return;
                      if (
                        exist.find(
                          (item) => item.value === codeRef.current.value
                        )
                      ) {
                        return;
                      }

                      add(codeRef.current)
                    }}
                    icon={<PlusOutlined />}
                  >
                    Add
                  </Button>
                </Col>
              </Row>
            </Form.Item>
          </>
        )}
      </Form.List>
      <strong>Style</strong>
      <Divider style={{ margin: "12px 0" }} />
      <ContentPadding />
    </>
  );
};
